/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FileViewsYamlFileQueryVariables = {|
  id: string
|};
export type FileViewsYamlFileQueryResponse = {|
  +node: ?{|
    +id: string,
    +dir?: ?string,
    +name?: ?string,
    +path?: ?string,
    +text?: ?string,
    +yaml?: ?any,
  |}
|};
export type FileViewsYamlFileQuery = {|
  variables: FileViewsYamlFileQueryVariables,
  response: FileViewsYamlFileQueryResponse,
|};
*/


/*
query FileViewsYamlFileQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    id
    ... on File {
      id
      dir
      name
      path
      text
      yaml
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dir",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "yaml",
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileViewsYamlFileQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileViewsYamlFileQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ccc73a8155b3f5c212747727133d253b",
    "id": null,
    "metadata": {},
    "name": "FileViewsYamlFileQuery",
    "operationKind": "query",
    "text": "query FileViewsYamlFileQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    id\n    ... on File {\n      id\n      dir\n      name\n      path\n      text\n      yaml\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '054e1e99811916aa5c93266f884a35fa';

module.exports = node;
